
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18.094 10.14a2.5 2.5 0 00-2.454-2.015H4.36a2.5 2.5 0 00-2.453 2.016L.673 16.39a2.5 2.5 0 002.452 2.984h13.75a2.5 2.5 0 002.453-2.984l-1.234-6.25z"}}),_c('path',{attrs:{"d":"M6.875 8.125V3.75a3.125 3.125 0 016.25 0v4.375m-7.5 0v11.25m8.75-11.25v11.25m-6.25-7.5h3.75"}})])])
          )
        }
      }
    